import * as React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { reduxForm, Field } from 'redux-form'
import classnames from 'classnames'
// @ts-ignore
import {
  ToggleSwitch,
  SelectV2,
  Input,
  // @ts-ignore
} from 'relevant-ui'
import '../form.scss'
import './style.scss'
import { Fields, defaultRoleSegments } from './types'
import ButtonWrapper from '@App/components/blocks/UiPage/Button'
import FormatText from '@App/helpers/formatText'
import InputField from '@App/components/fields/InputField'
import { ModalType, setShowModal } from '@App/store/modal'
import { formatArraySelect } from '@App/helpers/formatters'
import SelectField from '@App/components/fields/SelectField'
import { getNetworksList } from '@App/actions/networks'
import { getJobsUser } from '@App/actions/jobs'
import { getApplications } from '@App/store/application/actions'

class UserForm extends React.Component<any, any> {
  Ref: React.RefObject<any>

  constructor(props: any) {
    super(props)

    this.state = {
      userRoleValue: null,
      openSelect: false,
      initialRole: null,
      segmentList: [],
    }

    this.Ref = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.renderRoleList = this.renderRoleList.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
    this.updateSegments = this.updateSegments.bind(this)
  }

  componentDidMount() {
    const { current } = this.props

    document.addEventListener('click', this.handleClickOutside, true)

    let curentSegmentList: any = []
    current?.app?.map((el: any) => {
      return el.segments?.map((seg: any) => {
        return (curentSegmentList = [...curentSegmentList, seg.id])
      })
    })

    this.setState({
      segmentList: curentSegmentList,
      userRoleValue: this.props.initialRole,
    })

    this.props.getJobsUser()
    this.props.getNetworksList()
    this.props.getApplications()
  }

  handleClickOutside(event: KeyboardEvent) {
    if (!this.Ref?.current?.contains(event.target)) {
      this.setState({ openSelect: false })
    }
  }

  updateSegments(role = this.state.userRoleValue) {
    const { current, segments: applications, toggle } = this.props

    let segments = applications?.reduce((acc, app) => {
      return [
        ...acc,
        ...app.segments.map((segment: any) => (segment?.id)),
      ]
      // tslint:disable-next-line: align
    }, [])

    if (!current || !toggle) {
      segments = segments?.filter((el: any) =>
        defaultRoleSegments[role?.item?.value]?.includes(el),
      )
    } else {
      segments = current?.app?.reduce((acc, app) => {
        return [
          ...acc,
          ...app.segments.map((segment: any) => (segment?.id)),
        ]
        // tslint:disable-next-line: align
      }, [])
    }
    this.setState({
      segmentList: segments,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { current, initialRole } = this.props
    const { current: prevCurrent } = prevProps
    const { userRoleValue } = this.state
    const { userRoleValue: prevUserRoleValue } = prevState

    if (this.props.networksList?.length !== prevProps.networksList?.length) {
      this.props.getNetworksList()
    }

    if (current !== prevCurrent) {
      let curentSegmentList: any = []
      current?.app?.map((el: any) => {
        return el.segments?.map((seg: any) => {
          return (curentSegmentList = [...curentSegmentList, seg.id])
        })
      })

      this.setState({
        segmentList: curentSegmentList,
        userRoleValue: initialRole,
      })
      return
    }

    if (userRoleValue !== prevUserRoleValue) {
      this.updateSegments(userRoleValue)
    }
  }

  renderRoleList(roles) {
    return (
      <div className="selectField__list" ref={this.Ref}>
        <div className="selectField__list--container">
          {roles?.map((el: any) => {
            return (
              <p
                className="selectField__list--item"
                key={el.key}
                onClick={() =>
                  this.setState({
                    userRoleValue: {
                      ...el,
                      roleValue: el.item.value,
                    },
                  })
                }
              >
                {el.label}
              </p>
            )
          })}
        </div>
        <p
          onClick={() => this.props.setShowModal(ModalType.DEMO)}
          className="selectField__list--button"
        >
          {this.props.t('new_role')}
        </p>
      </div>
    )
  }

  handleToggle(bool, seg) {
    const { segmentList } = this.state
    if (bool) {
      this.setState({ segmentList: [...segmentList, seg.id] })

      return
    }

    this.setState({
      segmentList: segmentList.filter((el: any) => el !== seg.id),
    })

    return
  }

  handleScrollTo() {
    !this.Ref.current &&
      setTimeout(() => {
        this.Ref.current.scrollIntoView({ behavior: 'smooth' })
        // tslint:disable-next-line: align
      }, 100);
  }

  render() {
    const {
      toggle,
      current,
      t,
      handleCancel,
      handleDelete,
      handleSubmit,
      roles,
      jobsList,
      organizations,
      networksList,
      appList,
      setShowModal,
    } = this.props
    const { userRoleValue, segmentList } = this.state

    const list = appList?.filter(
      (item: any) => item.name !== 'Retargeting' &&
        item?.segments?.some((seg: any) => userRoleValue?.roleValue >= seg.minimumRoleValue,
    ))

    return (
      <form className="form form__connect">
        <div className="form__wrapper">
          {current?.title && (
            <section>
              <div className="form__header">
                <div className="form__header__left">
                  <div className="user">
                    <div className="user__media">
                      {current?.avatar ? (
                        <img src={current?.avatar} />
                      ) : (
                          <div className="user__media__withoutImg">
                            {current?.title[0]}
                          </div>
                        )}
                    </div>
                    <div className="user__desc">
                      <h2 className="user__desc__title">{current?.title}</h2>
                      <h3 className="user__desc__subtitle">{current.email}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          <section className="formWrapper">
            <h4 className="formWrapper__title mb-20">{t('informations')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('firstName')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.FIRSTNAME}
                    component={InputField}
                    label={t('firstName')}
                    placeholder={t('firstName')}
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('lastName')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.LASTNAME}
                    component={InputField}
                    label={t('lastName')}
                    placeholder={t('lastName')}
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('email')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.EMAIL}
                    component={InputField}
                    label={t('email')}
                    placeholder={t('email')}
                    disabled={toggle}
                    secondary
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="formWrapper">
            <h4 className="formWrapper__title mb-20">{t('organization_team')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('Organizations')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.ORGANISATION}
                    component={SelectField}
                    options={organizations}
                    placeholder={t('Organizations')}
                    disabled={current?.organization ? true : toggle}
                    onBlur={(e: any) => e.preventDefault()}
                  />
                </div>
              </div>
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('team')}
                </div>
                <div className="form__field__input">
                  <Field
                    name={Fields.TEAM}
                    component={SelectField}
                    options={jobsList}
                    placeholder={t('team')}
                    disabled={toggle}
                    onBlur={(e: any) => e.preventDefault()}
                  />
                </div>
                {!toggle && (
                  <div
                    className="segments__button"
                    onClick={() => setShowModal(ModalType.FORM)}
                  >
                    <p>{t('new_job')}</p>
                  </div>
                )}
              </div>
            </div>
          </section>
          <section className="formWrapper">
            <h4 className="formWrapper__title mb-20">{t('permissions_user')}</h4>
            <div className="formWrapper__fields">
              <div className="form__field form__field--small">
                <div className={FormatText.desableLabelField(toggle)}>
                  {t('role')}
                </div>
                <div className="form__field__input">
                  <div className="form__field__input form__field__input--more">
                    <div
                      className="selectField"
                      onClick={() =>
                        !toggle &&
                        this.setState({ openSelect: !this.state.openSelect })
                      }
                    >
                      <SelectV2
                        className={classnames(
                          'selectField__wrapper',
                          toggle && 'selectField__wrapper--isDisable',
                        )}
                        getElements={() => { }}
                        data={this.props.roles}
                        value={userRoleValue?.label}
                        placeholder={t('role')}
                        openChildren={toggle ? false : this.state.openSelect}
                      >
                        {this.renderRoleList(roles) as any}
                      </SelectV2>
                    </div>
                  </div>
                </div>
              </div>
              {userRoleValue?.value !== 1 && userRoleValue?.value !== 2 && (
                <div className="form__field form__field--small">
                  <div className={FormatText.desableLabelField(toggle)}>
                    {t('networks')}
                  </div>
                  <div className="form__field__input">
                    <Field
                      name={Fields.NETWORKS}
                      component={SelectField}
                      options={networksList}
                      onBlur={(e: any) => e.preventDefault()}
                      isDisabled={toggle}
                      isMulti
                    />
                  </div>
                </div>
              )}
            </div>
          </section>
          {userRoleValue?.roleValue !== 100 && (
            <section className="formWrapper formWrapper--noBorder">
              <h4 className="formWrapper__title mb-20">{t('Segments')}</h4>
              <div className="">
                {list?.map((el: any, index: number) => {
                  if (Array.isArray(el.segments) && el.segments.length !== 0) {
                    return (
                      <section
                        key={`${el.name}__${index}`}
                        className="segments__wrapper"
                      >
                        <h2 className="segments__title">{el.name}</h2>
                        <div className="segments__items">
                          {el?.segments?.map((seg: any, index: number) => {
                            if (userRoleValue?.roleValue >= seg.minimumRoleValue) {
                              const defaultValue = segmentList?.find(
                                (item: any) => item === seg.id,
                              )
                                ? true
                                : false

                              return (
                                <div
                                  key={`${seg.name}__${index}`}
                                  className="segments__item"
                                >
                                  <ToggleSwitch
                                    default={defaultValue}
                                    label={seg.name}
                                    onClick={(e) => {
                                      this.handleToggle(e, seg)
                                    }}
                                    disabled={toggle}
                                  />
                                </div>
                              )
                            }
                          })}
                        </div>
                      </section>
                    )
                  }
                  return
                })}
              </div>
            </section>
          )}
        </div>
        <ButtonWrapper
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          onDelete={handleDelete}
          dataTable={{ userRoleValue, segmentList }}
          disabled={false}
        />
      </form>
    )
  }
}

const validate = (values) => {
  const regexEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

  const errors = {}

  if (!values[Fields.FIRSTNAME]) {
    errors[Fields.FIRSTNAME] = 'Required'
  }

  if (!values[Fields.LASTNAME]) {
    errors[Fields.LASTNAME] = 'Required'
  }

  if (!values[Fields.EMAIL]) {
    errors[Fields.EMAIL] = 'Field cannot be empty'
  }

  if (values[Fields.EMAIL] && !regexEmail.test(values[Fields.EMAIL])) {
    errors[Fields.EMAIL] = 'Must be an email format'
  }

  if (!values[Fields.NETWORKS]) {
    errors[Fields.NETWORKS] = 'Required'
  }

  if (!values[Fields.TEAM]) {
    errors[Fields.TEAM] = 'Required'
  }

  if (!values[Fields.ORGANISATION]) {
    errors[Fields.ORGANISATION] = 'Required'
  }

  return errors
}

const NewUserForm = reduxForm({
  validate,
  form: Fields.FORM,
  enableReinitialize: true,
})(UserForm as any)

const mapStateToProps = (state: any) => {
  const {
    toggleFields: { toggle },
    users,
    roles,
    organizations,
    applications: { list },
    networks: { list: listNetworks },
    jobs: { list: jobsList },
    segments: {
      list: segmentList,
    },
  } = state

  const formattedRoles = formatArraySelect(roles?.list)
  const formattedNetworks = formatArraySelect(listNetworks)
  const formattedOrganizations = formatArraySelect(
    organizations && organizations.list,
  )

  let initialNetworks: any = []

  users.current?.networks?.map(
    (el: any) =>
      (initialNetworks = [
        ...initialNetworks,
        formattedNetworks.find((ntw: any) => ntw.value === el.networkId),
      ]),
  )

  let initialValues = {}

  if (users.current) {
    initialValues = {
      [Fields.FIRSTNAME]: users.current?.firstName || '',
      [Fields.LASTNAME]: users.current?.lastName || '',
      [Fields.EMAIL]: users.current?.email || '',
      [Fields.NETWORKS]: initialNetworks || '',
      [Fields.ORGANISATION]:
        // tslint:disable
        {
          label: users.current?.organization?.name,
          value: users.current?.organization?.id,
        } || '',
      // tslint:enable
      [Fields.TEAM]:
        { label: users.current?.job?.title, value: users.current?.job?.id } ||
        '',
    }
  }

  return {
    ...users,
    initialValues,
    toggle,
    segments: segmentList,
    initialRole: users?.current?.role,
    appList: list,
    networksList: formattedNetworks,
    roles: formattedRoles,
    organizations: formattedOrganizations,
    jobsList: jobsList.map((item) => {
      return { value: item.id, label: item.title }
    }),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setShowModal: (type: any) => dispatch(setShowModal(type)),
    getNetworksList: () => dispatch(getNetworksList()),
    getJobsUser: () => dispatch(getJobsUser()),
    getApplications: () => dispatch(getApplications()),
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
)(NewUserForm)
